import { getStorageItem, setStorageItem, STORAGE_KEYS } from 'src/utils/localStorageUtils';

export type TourStatus = 'completed' | 'dismissed';

interface TourRecord {
  status: TourStatus;
  version: number;
}

type TourStateMap = Record<string, TourRecord>;

// getStorageItem returns the stored `.value` even when it isn't the expected
// shape (valid JSON without a value object yields undefined despite the
// defaultValue) — normalize before property access so a corrupted entry can't
// throw inside the welcome-dialog effect.
function readMap(): TourStateMap {
  const map = getStorageItem<TourStateMap>(STORAGE_KEYS.TOUR_STATE, { defaultValue: {} });
  return map && typeof map === 'object' && !Array.isArray(map) ? map : {};
}

export function getTourRecord(tourId: string): TourRecord | null {
  return readMap()[tourId] ?? null;
}

export function setTourRecord(tourId: string, status: TourStatus, version: number): void {
  const map = readMap();
  map[tourId] = { status, version };
  setStorageItem(STORAGE_KEYS.TOUR_STATE, map);
}
